export default {
    app: {
        loading: 'Loading...',
    },
    global: {
        units: {
            thousand: 'th.',
            million: 'mil.',
            billion: 'bil.',
            trillion: 'tri.',
        },
        currency: {
            czk: 'CZK',
            kč: 'CZK',
            eur: 'EUR',
            points: '{points} points',
        },
        days: {
            today: 'Today',
            tomorrow: 'Tomorrow',
        },
    },
    header: {
        menuContent: {
            movies: 'Movies',
            cinestarClub: 'CineStar Club',
            events: 'Events',
        },
        chooseCinemaContent: {
            title: 'Confirm the pre-selected cinema or choose another',
        },
        shoppingCart: {
            tickets: '{count, plural, one {Ticket} few {Tickets} other {Tickets}}',
            minutes: '{count, plural, one {Minute} few {Minutes} other {Minutes}}',
        },
    },
    orderSteps: {
        first: 'Seat selection',
        second: 'Your order',
        third: 'Contact information',
        fourth: 'Summary <span>of order</span> and payment',
        fourthRes: 'Summary <span>of reservation</span> and confirmation',
    },
    userProfile: {
        title: 'Become a member of {br}Cinestar Club',
        description:
            'Get a discount of 20 CZK on each ticket, collect points for your expenses and choose rewards for free.',
        buttonOrder: 'ORDER MEMBERSHIP ONLINE',
        cardValidity: 'Your membership expires',
        menuBar: {
            ticketAndReservation: 'Tickets and reservations',
            cinestarClub: 'Cinestar Club',
            lostCard: 'Lost card',
            contactInfo: 'Contact info',
            passChange: 'Password change',
        },
        ticketsAndReserv: {
            title: 'Tickets and rezervations',
            ticket: 'Ticket',
            tickets: 'Tickets',
            orderNumber: 'order number',
            reservationNumber: 'reservation number',
        },
        cinestarClub: {
            title: 'Cinestar Club',
            clubNachos: 'Club nachos menu for free',
            missingPoints: 'You still need {points} points to get it.',
            coupons: {
                title: 'Coupons',
                noCoupons: 'You have no coupons',
            },
            rewards: {
                title: 'Rewards',
                noRewards: 'You have no rewards',
            },
            pointsOverview: {
                title: 'Overview of points',
                currentStatus: 'Current status',
                date: 'Date',
                purchase: 'Purchase',
                points: 'Points',
                loadMore: 'Load more',
            },
        },
    },
    hall: {
        hallHeader: {
            changeTime: 'Změnit čas',
            dateAndVenue: '{date}, {venue}',
            hallPicture: 'Hall picture',
            'gold-class': {
                title: 'GOLD CLASS',
                description: 'GOLD CLASS description',
            },
            deluxe: {
                title: 'THEATRE DELUXE',
                description: 'THEATRE DELUXE description',
            },
            subtitles: 'Subtitles',
        },
        legend: {
            title: 'Legend',
            zoom: 'Zoom',
            move: 'Move',
            seat: {
                classic: {
                    single: 'Classic seat',
                    double: 'Double seat',
                },
                vip: {
                    single: 'VIP seat',
                    double: 'VIP double seat',
                },
                gold: {
                    single: 'Gold seat',
                    double: 'Gold double seat',
                },
                deluxe: {
                    single: 'Deluxe seat',
                    double: 'Deluxe double seat',
                },
                wheelchair: {
                    single: 'Wheelchair seat',
                    double: 'Wheelchair seat',
                },
                positionable: {
                    single: 'Positionable seat',
                    double: 'Positionable seat',
                },
                selected: {
                    single: 'Selected',
                    double: 'Selected',
                },
                reserved: {
                    single: 'Reserved',
                    double: 'Reserved',
                },
            },
            seatDescription: {
                material: 'Material',
                width: 'Width',
                classic: {
                    single: 'seatDescription Klasické sedadlo',
                    double: 'seatDescription Dvojsedadlo',
                    material: 'classic material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                vip: {
                    single: 'seatDescription VIP sedadlo',
                    double: 'seatDescription VIP dvojsedadlo',
                    material: 'vip material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                gold: {
                    single: 'seatDescription GOLD sedadlo',
                    double: 'seatDescription GOLD dvojsedadlo',
                    material: 'gold material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                deluxe: {
                    single: 'seatDescription DELUXE sedadlo',
                    double: 'seatDescription DELUXE dvojsedadlo',
                    material: 'deluxe material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                wheelchair: {
                    single: 'seatDescription Místo pro vozíčkáře',
                    double: 'seatDescription Místo pro vozíčkáře',
                    material: 'wheelchair material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
                positionable: {
                    single: 'seatDescription Polohovatelné',
                    double: 'seatDescription Polohovatelné',
                    material: 'positionable material',
                    singleWidth: '50cm',
                    doubleWidth: '100cm',
                },
            },
        },
        screen: 'Screen',
    },
    basket: {
        btn: 'Continue',
        selectedSeats: 'Selected seats',
        totalPrice: 'Total price',
        totalPriceReservation: 'Total price of reservation',
        textOnlineReservation: 'when paying online, at a kiosk or in the app',
        textCashReservation: 'Price when paying at the cash register',
        reserveText: 'Price when paying for the reservation at the cash desk +{amount} {currency}',
        reserveBtn: 'Continue <span>to reservation</span>',
        buyBtn: 'Continue to purchase',
        paymentBtn: 'Pay',
        reservationBtn: 'Reserve',
    },
    yourOrder: {
        nextFilm: 'Next film',
        tickets: {
            title: 'Choose ticket type',
        },
        addTickets: {
            title: 'Add tickets for next movie',
            text: 'Add tickets',
        },
        addSnackCoupon: 'Add a snack coupon',
        throwAway: 'Throw away?',
    },
    contactInfo: {
        haveAccount: 'Have account',
        withoutLogin: 'Without login',
        buyWithoutLogin: 'Buy without login',
    },
    orderSummary: {
        ticketsDescription: {
            seat: 'Seat',
            type: 'Type',
            price: 'Price',
            paymentPoints: 'Payment points',
            totalPrice: 'Total order price',
            totalAmount: '{amount} Kč',
            maxTicketsLine: 'The club discount can be applied to a maximum of 4 tickets',
            extendMembershipLine: 'Membership in CineStar Club for 1 year',
        },
        haveAvailable: 'You have available',
        getSale: 'Get a discount of 20 CZK on each ticket.',
        giftVoucher: {
            title: 'Redeem Gift Voucher',
            info: 'Can be entered repeatedly',
            byPhoto: 'Take a photo / upload the code',
            byHand: 'Enter manually',
            number: 'Voucher number',
        },
        paymentMethod: 'Choose, how you want to pay',
        downloadAppTitle: 'Pay in the app or at the Kiosk and save 110 Kč.',
        downloadAppDesc:
            'If you pay for your reservation at a kiosk or in a mobile application, you will be charged an additional discount of CZK 110 for online payment, in contrast to paying at the cash desk.',
    },
    forms: {
        required: 'This field is required',
        register: {
            title: 'Registration',
            orFillText: 'Or fill in',
            nameLabel: 'Name',
            namePlaceholder: 'Name',
            nameError: 'name error',
            surnameLabel: 'Surname',
            surnamePlaceholder: 'Surname',
            surnameError: 'surname error',
            phoneLabel: 'Phone',
            phonePlaceholder: '789 123 456',
            phoneError: 'Phone number must follow the format 123456789 or 123 456 789',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'E-Mail',
            emailError: 'Invalid e-mail address',
            passwordLabel: 'Password',
            passwordPlaceholder: 'Enter your password',
            passwordError: 'password error',
            passwordConfLabel: 'Password again',
            passwordConfPlaceholder: 'For check',
            passwordConfError: 'password confirmation error',
            passwordMatchesEmail: "Password musn't match email address",
            passwordsMustMatch: 'Passwords must match',
            checkboxLabel: 'I agree with the General Terms and Condition',
            checkBoxNotChecked: 'You must agree to the General Terms and Conditions',
            buttonCreateMemberAccount: 'BECOME A MEMBER OF CINESTAR CLUB',
            buttonCreateBasicAccount: 'Create an account',
            clubMemberBenefits: {
                title: 'Become a member of the Cinestar Club',
                benefitDiscount: '20 CZK discount on each ticket',
                benefitRewards: 'Collect points for your expenses and choose free rewards.',
                benefitPoints: '10 points reward for registration.',
                feeText: 'Membership fee is 80 CZK per year.',
            },
            cinestarClubMember: {
                title: 'To complete your CineStar Club registration, please provide these additional details',
                gender: 'Gender',
                man: 'Man',
                woman: 'Woman',
                other: 'Other',
                dateLabel: 'Date of birth',
                datePlaceholder: 'Date of birth',
                dateError: 'date error',
                residenceLabel: 'Residence',
                residencePlaceholder: 'City',
                residenceError: 'residence error',
                postalCodeLabel: 'Postal code',
                postalCodePlaceholder: 'Postal code',
                postalCodeError: 'postal code error',
                agreement: {
                    title: 'Your agreements',
                    description:
                        'By agreeing, I confirm that I have read the terms and conditions of the CineStar Club loyalty program and the personal data processing conditions. Personal data is processed and protected in accordance with the law No. 101/2000 Coll. and the Personal Data Protection Regulation No. 679/2016. Agreement to the processing of personal data for sending commercial communications and other marketing activities (by e-mails, SMS, notifications):',
                    checkboxLabel: 'I agree to receive occasional newsletters and a birthday gift',
                    description2: 'By registering, you agree to our Terms and Conditions and Privacy Policy',
                },
                buttonBecomeMember: 'CREATE ACCOUNT AND BECOME A MEMBER OF CINESTAR CLUB',
            },
            errorLabel: 'Error',
            errorText: 'An error has occured during registration. Please try again later.',
        },
        login: {
            title: 'Login',
            orFillText: 'Or fill in',
            emailLabel: 'E-Mail',
            emailPlaceholder: 'E-Mail',
            emailError: 'Invalid e-mail address',
            passwordLabel: 'Password',
            passwordPlaceholder: 'Type your password',
            passwordError: 'password error',
            buttonLogin: 'LOGIN',
            buttonForgotten: 'Forgot your password?',
            buttonCreate: 'Create an account',
            unknownEmail: 'Incorrect email',
            wrongPassword: 'Incorrect password',
            internalErrorLabel: 'Error',
            internalErrorText: 'Sorry, an internal server error has occurred. We are working to fix the error.',
        },
        contactInfo: {
            title: 'Contact information',
        },
        agreements: {
            title: 'Your consents',
            description:
                'By giving my consent, I confirm that I have read and understood the terms and conditions of the CineStarClub loyalty program and the terms and conditions of personal data processing. Personal data are processed and protected in accordance with Act No. 101/2000 Coll. and Regulation on the Protection of Personal Data No. 679/2016. Consent to the processing of personal data for sending commercial messages and other marketing activities (by email, SMS, notifications):',
            nonPersonal: 'Consent to receive non-personalized advertising',
            personal:
                'Consent to receive personalized advertising: in order to send you information and advertisements that correspond to your personal interests, we analyze your purchased tickets, your participation in our advertising events and your use of our electronic services. For these purposes, we process the following personal data: email, age, gender, purchasing behavior, place of purchase (multicinema), film or other performance, film category, time of attendance, frequency of visited films, identification of similarities with other customers.',
            checkBoxNotChecked: 'You must choose one of the options.',
        },
        lostCard: {
            title: 'Lost Card',
            description: 'Here you can block your card in case of loss or theft.',
            label: 'I confirm that I want to block my club card',
            checkBoxNotChecked: 'You must agree to block the card.',
        },
        changePassword: {
            title: 'Change password and linked accounts',
            oldPasswordLabel: 'Old password',
            oldPasswordPlaceholder: 'Enter your old password',
            oldPasswordError: 'old password error',
            newPasswordLabel: 'New password',
            newPasswordPlaceholder: 'Enter your new password',
            newPasswordError: 'new password error',
            confirmationPasswordLabel: 'New password again',
            confirmationPasswordPlaceholder: 'For verification',
            confirmationPasswordError: 'password verification error',
            invalidPassword: 'Password is not valid',
            passwordMatchesEmail: 'Password must not be the same as email address',
            passwordsMustMatch: 'Passwords must match',
        },
        changeForgottenPassword: {
            title: 'Change password',
            newPasswordLabel: 'New password',
            newPasswordPlaceholder: 'Enter your password',
            newPasswordError: 'password error',
            confirmationPasswordLabel: 'Confirm new password',
            confirmationPasswordPlaceholder: 'For verification',
            confirmationPasswordError: 'password error',
            buttonChange: 'CHANGE PASSWORD',
            buttonCancel: 'Cancel',
            invalidPassword: 'Password is not valid',
            passwordMatchesEmail: 'Password must not match email address',
            passwordsMustMatch: 'Passwords must match',
            error: {
                text: 'We were not able to change your password. Please try again later.',
                notValid: 'The link is expired.',
            },
        },
        forgottenPassword: {
            title: 'Forgotten password',
            emailLabel: 'Enter your registration email.',
            emailPlaceholder: 'E-Mail',
            emailError: 'email error',
            buttonSend: 'SEND NEW PASSWORD',
            buttonCancel: 'CANCEL',
        },
        passwordValidation: {
            length: 'Must contain 8 to 16 characters.',
            letter: 'At least one letter.',
            number: 'At least one number.',
            email: 'It is not identical with e-mail address.',
        },
    },
    modals: {
        modalCinemaSelect: {
            title: 'Select a cinema',
            text: 'Please select a cinema to continue.',
        },
    },
    windows: {
        success: {
            title: 'Success',
            successful: 'Everything went smoothly.',
            contactInfo: 'Contact details successfully changed',
            gdpr: 'Your consents have been successfully changed',
            lostCard: 'Card blocked successfully.',
            registerClub: 'The request to Cinestar Club has been successfully sent.',
            changePassword: 'Password successfully changed.',
            changeForgottenPassword:
                'Your password has been changed. You will be automatically redirected in 3 seconds.',
            forgottenPassword: 'We have sent you an email with a link to reset your password.',
        },
        info: {
            title: 'Info',
            ticketTypes: {
                title: 'Ticket types',
                type: {
                    child: 'Child',
                    student: 'Student',
                    senior: 'Senior',
                    ztp: 'ZTP, ZTP/P',
                },
                description: {
                    child: 'Up to 12 years including. Children under 3 years old do not have to pay an admission fee, but do not have the right to their own seat.',
                    student: 'With a valid student ID card up to 26 years including',
                    senior: 'Over 60 years including',
                    ztp: 'Accompaniment of ZTP/P one person for free. For a ZTP, ZTP/P discount, a valid card must be presented.',
                },
            },
        },
        notification: {
            title: 'Notification',
            paidTitle: 'Paid!',
            noTicketsReserv: 'You currently have no purchased tickets or reservations',
            referenceNumber: 'Event reference number: {referenceNumber} (please keep for possible claim)',
            ticketsReserved:
                'Do not forget to pick up your reservation at the kiosk or at the cinema box office, at least 30 minutes before the show.',
            lights: 'This performance contains several scenes with strong flashing lights that may adversely affect viewers with photosensitive epilepsy or sensitivity to light.',
            onlyCards: 'For technical reasons, payment can only be made by credit card.',
            withoutPoints: 'Points from the Cinestar Club loyalty program cannot be used for this performance.',
            notShared: 'Tickets for this movie can no longer be purchased online.',
            reservedTickets:
                'You pay for the reservation at the cash desk, kiosk or via the mobile application. <bold>Tickets must be paid 30 minutes before the performance.</bold>',
            reservationPaid: 'You have already paid for this reservation.',
        },
        loading: {
            title: 'Loading',
            wait: 'Wait a moment please.',
        },
        error: {
            title: 'Chyba',
            somethingWrong: 'Něco se pokazilo. Zkuste to znovu později.',
            E_WS_PASSWORD_CHECK_FAILED: 'Zadané heslo není správné',
            forgottenPassword: 'Nebyli jsme schopni odeslat žádost o zapomenuté heslo. Prosím zkuste to znovu později.', //TODO add right error instead of forgottenPassword
            TOKEN_EXPIRED: 'Platnost relace vypršela.',
            TOKEN_MISSING: 'Platnost relace vypršela.',
            TOKEN_FAILED: 'Platnost relace vypršela.',
            E_WS_LOGIN_EXISTS: 'Účet s tímto e-mailem již existuje.',
            CANT_READ_QR_CODE: 'Qr kód se nepodařilo načíst. Zkontrolujte, že jste nahrál správný soubor.',
            CANT_APPLY_GIFT_VOUCHER: 'Dárkový voucher nebyl rozpoznán, nebo byl již uplatněn.',
            E_API_AUTHORIZATION_FAILED: 'Chybně zadané přihlašovací údaje.',
            TICKET_UNAVAILABLE: 'Některé z označených sedadel bylo již zabráno jiným uživatelem.',
            EMAIL_TICKET_ERROR:
                'Vstupenky se nepodařilo odeslat na Váš email. Vstupenky si můžete stáhnout na této stránce nebo ve Vašem profilu. V případě potíží kontaktujte technickou podporu. ',
            CANT_LOAD_MEAL_VOUCHERS_LIST: 'Nezdařilo se načíst seznam nabídky občerstvení.',
            E_API_LOGIN_NOT_EXISTS: 'S tímto emailem není propojen žádný účet.', // Chyba pro /forgotten-password když je zadán neexistující email
            DOWNLOAD_FAIL: 'Nepodařilo se stáhnout vstupenky a vouchery.',
            API_TOKEN_MISSING: 'Platnost relace vypršela.',
            API_TOKEN_FAILED: 'Platnost relace vypršela.',
            E_API_TOKEN_NOT_FOUND: 'Platnost relace vypršela.',
            E_LP_POINTS_EXCEEDED: 'Nemáte dostatek bodů.',
            E_TICKET_FOR_VOUCHER_1_AND_1_NOT_FOUND: 'Je třeba přidat další vstupenku.',
            API_PAY_BY_POINTS_NOT_ALLOWED: 'Nelze uplatnit body.',
            API_PAY_BY_POINTS_PAYMENT_NOT_DEFINED_OR_SUPPORTED: 'Nelze uplatnit body.',
            E_API_BOOKING_CANCEL_STATE: 'Tato rezervace není aktivní.',
            E_API_BOOKING_CANCEL_DISABLED: 'Rezervaci nelze stornovat.',
            API_CART_IS_EMPTY_OR_RELEASED: 'Košík je prázdný.',
            API_CART_PAYMENT_NOT_SELECTED: 'Vyberte typ platby.',
            API_CART_PERSON_DATA_MISSING: 'Je třeba se přihlásit nebo vyplnit osobní data.',
            E_API_CARD_ALREADY_IN_CART: 'Karta je již v košíku.',
            API_REGISTRATION_PASSWORD: 'Přihlášení se nezdařilo.',
            API_REGISTRATION_EMAIL: 'Přihlášení se nezdařilo.',
            API_REGISTRATION_NAME_SURNAME: 'Přihlášení se nezdařilo.',
            API_REGISTRATION_PHONE: 'Přihlášení se nezdařilo.',
            API_CHANGE_PASSWORD_EMPTY: 'Změna hesla se nepodařila.',
            E_API_ALREADY_AUTHORIZED: 'Uživatel je již přihášen.',
            E_WS_ACCOUNT_NOT_ACTIVE: 'Přihlášení se nezdařilo.',
            E_API_CATEGORY_NOT_SHARED: 'Kategorie není povolená.',
            E_API_ACCOUNT_ALREADY_EXISTS: 'Účet již existuje.',
            API_AUTHORIZATION_FAILED: 'Přihlášení se nezdařilo.',
            API_ITEM_OCCUPIED: 'Položka již není k dispozici.',
            API_VALIDITY_EXCEEDED: 'Rezervaci již nelze vytvořit.',
            API_LOGIN_EXISTS: 'Účet již existuje.',
        },
        warning: {
            TOO_MANY_SEATS: 'Please only select 6 seats',
            DIFFERENT_CINEMA: 'There has been a change of cinema, your basket has been emptied.',
            somethingWrong: 'Something went wrong. Try again later.',
        },
    },
    paymentVerify: {
        paymentIsBeingVerified: 'Your payment is being verified',
    },
    thanksForOrder: {
        title: 'Thank you for your order',
        subtitle: 'We have sent the tickets to your email.',
        findThem: 'You can also find them in <redirect>your account</redirect>.',
        sendThem: ' Send tickets via SMS',
    },
    ticketsReserved: {
        title: 'Tickets reserved',
    },
    page404: {
        pageTitle: 'Wrong direction!',
        title: 'We apologize,',
        description: '... but this page was not found.',
        button: 'Back to the main page',
    },
    page500: {
        pageTitle: 'Unexpected Error',
        title: 'We apologize,',
        description: '... but this page is not working at the moment. Please try again later.',
        button: 'Back to the Cinestar site',
    },
    paymentFailed: {
        pageTitle: 'Online payment failed',
        title: 'There was a problem during the payment and the order could not be paid.',
        description:
            'Now you can either cancel it - which will release the selected seats, or return it to the cart and choose a different type of delivery and payment.',
        button1: 'RETURN TO THE CART',
        button2: 'Cancel order',
    },
    expiredLimit: {
        pageTitle: 'Page validity has expired',
        title: 'The time limit for completing the purchase has been exceeded',
        description: 'Next time, you have to hurry.',
        button: 'BACK TO THE SHOW SELECTION',
    },
    ticket: {
        type: {
            basic: 'Basic',
            child: 'Child',
            student: 'Student',
            senior: 'Senior',
            ztp: 'ZTP',
            club: 'CineStar Club for 1 year',
        },
        pointPayment: 'Redeem {points} points',
    },
    buttons: {
        yes: 'Yes',
        no: 'No',
        back: 'Back',
        close: 'Close',
        continue: 'CONTINUE',
        login: 'Login',
        register: 'Register',
        logout: 'Logout',
        add: 'Add',
        confirm: 'CONFIRM',
        confirmVoucher: 'CONFIRM VOUCHER',
        buttonSave: 'SAVE CHANGES',
        chooseCinema: 'Choose cinema',
        downloadTickets: 'Download tickets',
        downloadApp: 'Download application',
        send: 'SEND',
        apply: 'APPLY',
        extendMembership: 'Extend <span>membership</span>',
        orderMembership: 'Order membership online',
        social: 'Continue with <spanCapitalize>{variant}</spanCapitalize>',
        goToAccount: 'Go to profile',
        moreInfo: 'More Information',
        payReservation: 'Pay reservation',
        cancelReservation: 'Cancel reservation',
        downloadReservation: 'Download reservation',
        toggle: {
            label: {
                basic: 'Basic',
                child: 'Child',
                student: 'Student',
                senior: 'Senior',
                ztp: 'ZTP',
                Dítě: 'Child',
                Senior: 'Senior',
                Student: 'Student',
                ZTP: 'ZTP',
                'CineStar Club': 'CineStar Club',
            },
        },
    },
    demo: {
        title: 'Demo page',
        typography: 'Typography component demo',
    },
    mailSender: {
        forgottenPassword: {
            subject: 'Cinestar - Forgotten password',
            content: 'To change your password click the link:',
        },
    },
    footer: {
        copyright: {
            advertising: 'The exclusive advertising agency is Cinexpress',
            regulations: 'Visitor regulations',
            terms: 'Terms of personal data processing',
            conditions: 'General terms and conditions',
            cinestar: 'CineStar s.r.o. © {year}',
            designBy: 'Design by Symbio',
        },
    },
}
